import { render, staticRenderFns } from "./LearningPathCard.vue?vue&type=template&id=4f637956&scoped=true&"
import script from "./LearningPathCard.vue?vue&type=script&lang=js&"
export * from "./LearningPathCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningPathCard.vue?vue&type=style&index=0&id=4f637956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f637956",
  null
  
)

export default component.exports